import { DateTime } from 'luxon';

import { Item } from '../models/item.model';

const technicalFields = [
  'editedBy',
  'updatedAt',
  'opportunityStatus',
  'expirationNotifications',
];

const hasChangesExcluding = (
  before: unknown,
  after: unknown,
  fieldsToExclude: string[]
): boolean => {
  if (before === after) return false;
  if (typeof before !== typeof after) return true;
  if (typeof before !== 'object') return true;
  if (!before || !after) return true;

  if (Array.isArray(before) && Array.isArray(after)) {
    if (before.length !== after.length) return true;
    return before.some((value, index) =>
      hasChangesExcluding(value, after[index], fieldsToExclude)
    );
  }

  const beforeObject = before as Record<string, unknown>;
  const afterObject = after as Record<string, unknown>;
  const beforeKeys = Object.keys(beforeObject).filter(key => !fieldsToExclude.includes(key));
  const afterKeys = Object.keys(afterObject).filter(key => !fieldsToExclude.includes(key));

  if (beforeKeys.length !== afterKeys.length) return true;

  return beforeKeys.some(key =>
    !afterKeys.includes(key) ||
    hasChangesExcluding(beforeObject[key], afterObject[key], fieldsToExclude)
  );
};

export const isApprovedExpirationOnlyExtension = (before: Item, after: Item): boolean => {
  if (before.opportunityStatus !== 'active') return false;

  const beforeExpiration = DateTime.fromISO(before.expirationDate);
  const afterExpiration = DateTime.fromISO(after.expirationDate);

  if (!beforeExpiration.isValid ||
    !afterExpiration.isValid ||
    afterExpiration.toMillis() <= beforeExpiration.toMillis()) {
    return false;
  }

  return !hasChangesExcluding(
    before,
    after,
    [...technicalFields, 'expirationDate']
  );
};
